export default {
  notification_one: '{{count}} notification',
  notification_other: '{{count}} notifications',
  notification_max: '99+ notifications ',
};
